import type { ComplianceRange } from '../types';

/** Six-step compliance scale, from full compliance to none. */
export const COMPLIANCE_RANGES: readonly ComplianceRange[] = [
  { key: '100', label: '100%', min: 100, max: 100, color: '#1F7A3D' },
  { key: '85-99', label: '85–99%', min: 85, max: 99, color: '#4CAF50' },
  { key: '70-84', label: '70–84%', min: 70, max: 84, color: '#F59E0B' },
  { key: '50-69', label: '50–69%', min: 50, max: 69, color: '#D97706' },
  { key: '1-49', label: '1–49%', min: 1, max: 49, color: '#EF4444' },
  { key: '0', label: '0%', min: 0, max: 0, color: '#991B1B' },
];

export const isInComplianceRange = (value: number, range: Pick<ComplianceRange, 'min' | 'max'>) =>
  value >= range.min && value <= range.max;

/** Traffic-light color (green / yellow / red) for a compliance percentage. */
export const getComplianceColor = (value: number): string => {
  if (value >= 70) {
    return '#52c41a';
  }

  return value > 40 ? '#faad14' : '#ff4d4f';
};

/** Color of the six-step scale that a compliance percentage falls into. */
export const getComplianceScaleColor = (percentage: number): string => {
  if (percentage >= 100) return COMPLIANCE_RANGES[0].color;
  if (percentage >= 85) return COMPLIANCE_RANGES[1].color;
  if (percentage >= 70) return COMPLIANCE_RANGES[2].color;
  if (percentage >= 50) return COMPLIANCE_RANGES[3].color;
  if (percentage > 0) return COMPLIANCE_RANGES[4].color;
  return COMPLIANCE_RANGES[5].color;
};
